//用于定义全局控件
import SelectUserInfo from "@/pccomponents/SelectUserInfo"
import SelectDeptInfo from "@/pccomponents/SelectDeptInfo"
import SelectListInfo from "@/pccomponents/SelectListInfo"
import SelectTreeInfo from "@/pccomponents/SelectTreeInfo"
import SelectTreeTagInfo from "@/pccomponents/SelectTreeTagInfo"
import fftag from "@/pccomponents/fftag"
import FfBreadcb from "@/pccomponents/FfBreadcb"
import rowtag from "@/pccomponents/rowtag"
import Pagination from "@/pccomponents/Pagination";
import DetailFlow from "@/pccomponents/detailFlow";
import TreeTag from "@/pccomponents/TreeTag";
import Vue from 'vue'
import ffbtn from "@/pccomponents/ffbtn";
import NoDataDisplay from "@/pccomponents/NoDataDisplay"
import ffapplydept from "@/pccomponents/ffapplydept";
import ffApplyselect from "@/pccomponents/ffApplyselect";
import FileUpload2 from "@/pccomponents/FileUpload2";
//注册人员选择框为全局控件
Vue.component('select-user-info', SelectUserInfo)

//注册部门选择框为全局控件
Vue.component('select-dept-info', SelectDeptInfo)

//注册行项列表选择框为全局控件
Vue.component('select-list-info', SelectListInfo)

//注册树选择框为全局控件
Vue.component('select-tree-info', SelectTreeInfo)
//注册树选择框为全局控件 新
Vue.component('select-tree-tag-info', SelectTreeTagInfo)

//注册表单控件为全局控件
Vue.component('fftag', fftag)

//注册面包屑控件为全局控件
Vue.component('ff-breadcb', FfBreadcb)

//注册行项控件为全局控件
Vue.component('rowtag', rowtag)

//注册分页条控件为全局控件
Vue.component('Pagination', Pagination)

//注册流程为全局控件
Vue.component('detail-flow',DetailFlow)

//注册分页条控件为全局控件
Vue.component('tree-tag', TreeTag)

//注册权限按钮全局控件
Vue.component('ffbtn', ffbtn)

//注册暂无数据展示控件
Vue.component('no-data-display', NoDataDisplay)

//注册列表申请部门下拉框控件
Vue.component('ffapplydept', ffapplydept)

//注册列表新增条件下拉框控件
Vue.component('ff-applyselect', ffApplyselect)

//上传附件
Vue.component('file-upload2', FileUpload2)


// WEBPACK FOOTER //
// ./src/pccomponents/index.js